import { useTranslation } from "react-i18next";
import dossierService, {
  IDossierAddFile,
  IGetItemsRequest,
} from "api/dossierService";
import tagsService from "api/tagsService";
import NoFilesIcon from "assets/icons/nofiles.svg?react";
import FolderIcon from "assets/icons/dossierNew.svg?react";
import DriveIcon from "assets/icons/hard_drive.svg?react";
import DocIcon from "assets/icons/doc.svg?react";
import PptIcon from "assets/icons/ppt.svg?react";
import XlsIcon from "assets/icons/xls.svg?react";
import OtherIcon from "assets/icons/other.svg?react";
import AddButton from "components/AddButton";
import Button from "components/Button";
import DossierFilesContext from "contexts/DossierFilesContext";
import KeysContext from "contexts/KeysContext";
import ModalsManagerContext, { defaultValue } from "contexts/ModalsManager";
import { ICase } from "dto/Cases/ICase";
import { IDossierItem } from "dto/Dossier/IDossierItem";
import { ItemKind } from "dto/IKindItems";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useAuth } from "react-oidc-context";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { decryptFile } from "utils/decryptFile";
import { getBlob } from "utils/getBlob";
import { getFile } from "utils/getFile";
import { getUserId } from "utils/getUserId";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import CopyIcon from "assets/icons/copy-new.svg?react";
import CutIcon from "assets/icons/cut.svg?react";
import DeleteIcon from "assets/icons/bin.svg?react";
import DeskIcon from "assets/icons/book.svg?react";
import CloseIcon from "assets/icons/close.svg?react";
import { ENotificationType, notification } from "utils/notification";
import { handleCreate } from "utils/uploadFile";
import { createDossierObject } from "./createDossierObject";
import statusService from "api/statusService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IDossierFolderPathFolder } from "dto/Dossier/IDossierFolderPathFolder";
import { IDossierFolder } from "dto/Dossier/IDossierFolder";
import { DossierItemType } from "dto/Dossier/DossierItemType";
import { IKey } from "dto/IKey";
import useStateRef from "utils/useStateRef";
import { addCopyToFileName } from "utils/addCopyToFileName";
import Spinner from "components/Spinner";
import ConfirmModal from "components/ConfirmModal";
import PreviewModal from "components/PreviewModal";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import DossierFolderModal from "components/DossierFolderModal";
import CasePreviewModal from "components/CasePreviewModal";
import { readFileFromBase64 } from "utils/readFileFromBase64";
import * as openpgp from "openpgp";
import { randomString } from "utils/randomString";
import { DropTargetMonitor, useDrag, useDrop } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";
import pluginService from "api/pluginService";
import PluginNotExist from "components/PluginNotExist";
import { useOnClickOutside } from "usehooks-ts";
import {
  DataGridPremium,
  GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
  GridCellEditStartParams,
  GridCellEditStartReasons,
  GridColDef,
  GridColumnVisibilityModel,
  GridInitialState,
  GridPremiumSlotsComponent,
  GridRenderCellParams,
  GridRow,
  GridSortModel,
  MuiEvent,
  useGridApiContext,
  useGridApiRef,
  useKeepGroupedColumnsHidden,
  GridDataSource,
  DataGridPremiumProps,
  gridRowsLookupSelector,
} from "@mui/x-data-grid-premium";
import InputInline from "components/InputInline";
import prettyBytes from "pretty-bytes";
import NameCell from "./Cells/NameCell";
import StatusCell from "./Cells/StatusCell";
import TagCell from "./Cells/TagCell";
import IconsCell from "./Cells/IconsCell";
import MenuCell from "./Cells/MenuCell";
import { Box, CircularProgress, LinearProgress } from "@mui/material";
import { logger } from "utils/logger";
import { plGridLocales } from "utils/muiGridLocales";
import { useDownloadFileStore } from "store/downloadFile.store";
import moment from "moment";
import DossierCreateVersionModal from "components/DossierCreateVersionModal";
import { useDossierStore } from "store/dossier.store";
import { IContextMenu } from "./Cells/MenuCell/typings";
import PackageEditSharesModal from "components/PackageEditSharesModal";
import DossierMoveModal from "components/DossierMoveModal";
import NotFoundScreen from "components/NotFoundScreen";
import { nullHandlingSortComparator } from "utils/nullHandlingSortComparator";
import { GridInitialStatePremium } from "@mui/x-data-grid-premium/models/gridStatePremium";
import { TagType } from "dto/ITag";
import { useKeyPressEvent } from "react-use";
import CustomToolbar from "./Toolbar";
import { ListType } from "dto/ListType";
import { StatusType } from "dto/IStatus";
import { IGridFilter } from "dto/IGridFilter";
import classNames from "classnames";
import { getKeys } from "utils/getKeys";
import { useDebounce } from "use-debounce";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { SignalRContext } from "../../App";
import { HubCallbacksNames } from "api/hub";
import useGridRowSelection from "hooks/useGridRowSelection";

const CustomToolbar2 = ({
  setShowCreateMenu,
  showCreateMenu,
  caseId,
  handleCreateFolder,
  setModals,
  handleCreateEditorDocument,
  onlyDesk,
  navigateToRoot,
  currentFolder,
  folderData,
  folder,
  isLoading,
  hideCreate,
  isTrash,
  onEmptyTrash,

  statusId,
  setStatusId,
  tagId,
  setTagId,
  editFilter,
  setEditFilter,
  searchText,
  setSearchText,
}: {
  setGroup: (v: boolean) => void;
  group: boolean;
  setShowCreateMenu: (v: boolean) => void;
  showCreateMenu: boolean;
  caseId: string;
  handleCreateFolder: () => void;
  setModals: (any) => void;
  handleCreateEditorDocument: (t: string) => void;
  onlyDesk: boolean;
  navigateToRoot: () => void;
  currentFolder: IDossierItem;
  folderData: IDossierFolder;
  folder: IDossierFolder;
  isLoading: boolean;
  hideCreate: boolean;
  isTrash?: boolean;
  onEmptyTrash?: () => void;

  editFilter?: IGridFilter;
  setEditFilter?: (filter: IGridFilter) => void;
  statusId?: number;
  setStatusId: (s: number) => void;

  tagId?: string;
  setTagId: (tagId: string) => void;

  showSearch?: boolean;
  searchText?: string;
  setSearchText: (tagId: string) => void;
}) => {
  const createMenuRef = useRef(null);
  const { t } = useTranslation();

  useOnClickOutside(createMenuRef, () => setShowCreateMenu(false));

  return (
    <CustomToolbar
      listName="dossier"
      listType={ListType.EditorDocuments}
      editFilter={editFilter}
      setEditFilter={setEditFilter}
      tagType={TagType.EditorDocuments}
      statusType={StatusType.EDITORDOCUMENTS}
      setStatusId={setStatusId}
      statusId={statusId}
      setTagId={setTagId}
      tagId={tagId}
      showColumnGrouping={true}
      leftChildren={
        <div className={styles.path}>
          {!onlyDesk && (
            <div className={styles.root} onClick={() => navigateToRoot()}>
              {t("dossier.myDrive")}
            </div>
          )}
          {currentFolder && (
            <>
              <FontAwesomeIcon className={styles.arrow} icon={faAngleRight} />
              {folderData &&
                folderData.Path &&
                folderData.Path.map((p: IDossierFolderPathFolder) => (
                  <>
                    <div
                      className={styles.pathItem}
                      onClick={() =>
                        //@ts-ignore
                        onFolderDoubleClick?.({
                          Id: p.Id,
                          DossierId: p.Id,
                          CreationDate: new Date(),
                          LastModified: new Date(),
                          Kind: ItemKind.DossierFolder,
                          Label: p.Name,
                          Type: DossierItemType.Folder,
                          CommentsCount: 0,
                          DeskInfo_IsOn: false,
                          IsShared: false,
                          TagCount: 0,
                        })
                      }
                    >
                      {p.Name}
                    </div>
                    <FontAwesomeIcon
                      className={styles.arrow}
                      icon={faAngleRight}
                    />
                  </>
                ))}

              <div className={styles.current}>{folder?.Name}</div>
            </>
          )}
          {isLoading && <Spinner className={styles.spinner}></Spinner>}
        </div>
      }
      showSearch={!!caseId}
      searchText={searchText}
      setSearchText={setSearchText}
      rightChildren2={
        <>
          {isTrash ? (
            <Button
              className={styles.addButton}
              text={t("dossier.emptyTrash")}
              onClick={() => onEmptyTrash?.()}
            />
          ) : (
            !hideCreate && (
              <AddButton
                className={styles.addButton}
                text={t("common.new")}
                onClick={() => setShowCreateMenu?.(!showCreateMenu)}
              />
            )
          )}

          {showCreateMenu && (
            <div className={styles.createMenu} ref={createMenuRef}>
              {caseId && (
                <div
                  onClick={() => {
                    handleCreateFolder?.();
                    setShowCreateMenu(false);
                  }}
                  className={styles.menuItem}
                >
                  <FolderIcon /> Folder
                </div>
              )}

              <div
                onClick={() => {
                  setModals({
                    ...defaultValue,
                    createDossier: true,
                    hide: false,
                  });
                  setShowCreateMenu(false);
                }}
                className={styles.menuItem}
              >
                <DriveIcon /> {t("dossier.fileOrLink")}
              </div>
              <div className={styles.line}></div>
              <div
                onClick={() => handleCreateEditorDocument("docx")}
                className={styles.menuItem}
              >
                <DocIcon /> Word
              </div>
              <div
                onClick={() => handleCreateEditorDocument("pptx")}
                className={styles.menuItem}
              >
                <PptIcon /> PowerPoint
              </div>
              <div
                onClick={() => handleCreateEditorDocument("xlsx")}
                className={styles.menuItem}
              >
                <XlsIcon /> Excel
              </div>
              <div
                onClick={() => handleCreateEditorDocument("other")}
                className={styles.menuItem}
              >
                <OtherIcon /> {t("dossier.other")}
              </div>
            </div>
          )}
        </>
      }
    ></CustomToolbar>
  );
};

const CaseDossier: FC<Props> = ({
  Case,
  className = "",
  isOutcoming = false,
  setCurrentFolderToCaseView,
  allInOne = false,
  shares = false,
  filterId,
  searchText,
  previewInModal,
  onlyDesk = false,
  fType,
  hideCreate = false,
  hideToolbar = false,
  miniMode = false,
  createFolder: createFolderOnInit,
  setCreateFolder: setCreateFolderOnInit,
  hideColumnHeader,
}) => {
  const { t } = useTranslation();
  const { selectedRowIds, rowsRef, handleRowClick } = useGridRowSelection();
  const navigate = useNavigate();

  console.log("CaseDossier");

  const { isError: isPluginError } = pluginService.useGetVersion();

  const { caseId: caseIdFromParams } = useParams();
  const caseId = Case?.Id ?? caseIdFromParams;

  const { keys, setKeys } = useContext(KeysContext);
  const [showCreateVersion, setShowCreateVersion] = useState(false);
  const [showMove, setShowMove] = useState(false);
  const [showShare, setShowShare] = useState(false);

  const [searchText2, setSearchText2] = useState<string>("");
  const [debouncedText] = useDebounce(searchText2, 300);

  const { selectedItems, setSelectedItems } = useDossierStore();
  const { mutate: deleteDossier } = dossierService.useDeleteDossier();

  const [showPluginError, setShowPluginError] = useState<boolean>(false);
  const {
    id: downloadId,
    setId: setDownloadId,
    progress: downloadProgress,
    setProgress: setDownloadProgress,
  } = useDownloadFileStore();

  const [selectedFolder] = useState<IDossierItem | null>(null);
  const [showCreateMenu, setShowCreateMenu] = useState<boolean>(false);

  // Statyczny filtr "Kosz" (GUID z backendu) — widok usuniętych plików + opróżnianie kosza.
  const KOSZ_FILTER_ID = "5e54d0f3-aae1-4e82-b558-5e72a15dc0ec";
  const isTrashView = (filterId ?? "").toLowerCase() === KOSZ_FILTER_ID;
  const [showEmptyTrash, setShowEmptyTrash] = useState<boolean>(false);
  const { mutate: emptyTrash } = dossierService.useEmptyTrash();

  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [showFolderPreview, setShowFolderPreview] = useState<boolean>(false);
  const [showPreviewCase, setShowPreviewCase] = useState<boolean>(false);
  const [previewItem, setPreviewItem] = useState<IDossierItem | null>(null);
  const [activeElement, setActiveElement] = useState<IDossierItem | null>(null);

  // Jedna firma na użytkownika, bez przełącznika kontekstu (decyzja D1) — nie ma już
  // zdarzenia "zmiana firmy" w trakcie sesji, więc zamykanie podglądu/zaznaczenia po takiej
  // zmianie jest zbędne (dawne useOnProfileChange nigdy by się tu nie odpaliło).

  const { modals, setModals, setOptions } = useContext(ModalsManagerContext);
  const { dossierFiles, setDossierFiles } = useContext(DossierFilesContext);

  const { mutate: updateLabel } = dossierService.useUpdateLabel();

  const commitLabel = (dossierId: string, newLabel: string) => {
    updateLabel(
      {
        Id: dossierId,
        Label: newLabel ?? "",
      },
      {
        onSuccess: () => {
          updateRowEditMode(dossierId, false, newLabel);
        },
      },
    );
  };

  const [filterStatusId, setFilterStatusId] = useState<number>(null);
  const [filterTagId, setFilterTagId] = useState<string>(null);
  const [editFilter, setEditFilter] = useState<IGridFilter>(null);

  const { mutate: moveDossier } = dossierService.useMoveDossier();
  const { mutateAsync: createFolder } = dossierService.useCreateFolder();

  const dataSource: GridDataSource = useMemo(() => {
    console.log("Memo changed");

    return {
      getRows: async (params) => {
        const request: IGetItemsRequest = {
          CaseId: caseId,
          IncludeFolders: !allInOne || fType == DossierItemType.Folder,
          Shared: shares ? true : undefined,
          FilterId: filterId,
          Text: debouncedText?.length > 0 ? debouncedText : searchText,
          ShowInDesk: onlyDesk,
          Type: fType,

          StatusId: filterStatusId,
          TagId: filterTagId,
          Start: params.start,
          End: params.end,
          PaginationModel: params.paginationModel,
          FilterModel: params.filterModel,
          SortModel: params.sortModel,
          GroupKeys: params.groupKeys,
          GroupFields: params.groupFields,
        };

        const getRowsResponse = await dossierService.getItems(request);

        // if (params.groupKeys && params.groupKeys.length>0){
        //   if (getRowsResponse.data.Items.length === 0){

        //   }
        // }
        setKeys([
          ...keys,
          ...(getRowsResponse.data.Keys ?? []),
          ...(getRowsResponse.data.ObjectKeys ?? []),
        ]);
        setDossierFiles([...dossierFiles, ...getRowsResponse.data.Items]);

        return {
          rows: getRowsResponse.data.Items.map((row) => ({
            ...row,
            id: row.DossierId,
          })),
          rowCount: getRowsResponse.data.Total,
        };
      },
      getGroupKey: (row) => {
        return row.DossierId;
      },
      getChildrenCount: (row) => {
        return row?.Type === DossierItemType.Folder ? row.ChildrenCount : 0;
      },
      updateRow: async () => {
        // update row on the server
      },
    };
  }, [
    caseId,
    filterId,
    debouncedText,
    searchText,
    filterStatusId,
    filterTagId,
  ]);

  const refetch = () => {
    if (!apiRef?.current?.dataSource) return;
    console.log("Refetching dossier");
    apiRef.current.dataSource.cache.clear();
    apiRef.current.setRows([]);
    apiRef.current.dataSource.fetchRows(undefined, {
      keepChildrenExpanded: true,
      skipCache: true,
    });
  };

  SignalRContext.useSignalREffect(
    HubCallbacksNames.NewDossierItem,
    (message) => {
      console.log("Got new dossierItem", message, caseId);
      if (message.caseId === caseId || !caseId) {
        if (apiRef?.current) {
          const row = apiRef.current.getRow(message.dossierId);

          if (row) {
            console.log("Updating existing row in dossier", row);
            apiRef.current.updateRows([
              {
                id: message.dossierId,
                StatusId: message.statusId,
                FileName: message.fileName,
                FileUri: message.fileUri,
                SignedPdfUri: message.signedPdfUri,
                SignedXadesUri: message.signedXadesUri,
                TagIds: message.tagIds,
                LastModified: message.lastModified,
                Flags: message.flags,
                ChildrenCount: message.childrenCount,
                VersionsCount: message.versionsCount,
                Label: message.label,
                FileSize: message.fileSize,
                LastOpened: message.lastOpened,
              },
            ]);
          } else {
            console.log("Refetching grid");
            refetch();
          }

          let items = [...dossierFiles];

          const toUpdate = items.find((x) => x.DossierId === message.dossierId);

          if (toUpdate) {
            toUpdate.FileName = message.fileName;
            toUpdate.FileUri = message.fileUri;
            toUpdate.SignedPdfUri = message.signedPdfUri;
            toUpdate.StatusId = message.statusId;
            toUpdate.SignedXadesUri = message.signedXadesUri;
            toUpdate.LastOpened = message.lastOpened;
          } else {
            items = [
              ...items,
              {
                Id: message.Id,
                DossierId: message.dossierId,
                StatusId: message.statusId,
                FileName: message.fileName,
                SignedPdfUri: message.signedPdfUri,
                SignedXadesUri: message.signedXadesUri,
                TagIds: message.tagIds,
                LastModified: message.lastModified,
                ChildrenCount: message.childrenCount,
                VersionsCount: message.versionsCount,
                Label: message.label,
                CommentsCount: message.commentsCount,
                CreationDate: message.creationDate,
                DeskInfo_IsOn: message.deskInfo_IsOn,
                IsShared: message.isShares,
                EncryptionKeyId: message.encryptionKeyId,
                Kind: message.kind,
                Type: message.type,
                Keys: message.keys,
                ObjectKeys: message.objectKeys,
                TagCount: message.tagCount,
              },
            ];
          }
        } else {
          refetch();
        }
      }
      // notification({
      //   title: `Użytkownik OFFLINE`,
      //   text: `Inny użytkownik OFFLINE: ${message.userId}`,
      //   type: ENotificationType.ERROR,
      // });
    },
    [],
  );

  const [folder] = useStateRef<IDossierFolder | null>(null);

  const [isDossierLoading] = useState<boolean>(false);

  const { data: tagsData, isLoading: isTagsLoading } = tagsService.useGetTags();
  const tags = useMemo(() => tagsData?.data ?? [], [tagsData]);
  const { data: statusesData, isLoading: isStatusesLoading } =
    statusService.useGetStatuses();

  const statuses = useMemo(() => statusesData?.data ?? [], [statusesData]);

  const key: IKey = useMemo(() => (Case?.Keys?.[0] as IKey) ?? null, [Case]);

  useEffect(() => {
    if (Case) {
      setKeys([...keys, ...(Case?.Keys ?? [])]);
    }
  }, [Case]);

  const getStatus = (item: IDossierItem) => {
    if (!item.StatusId) return null;

    const s = statuses.find((x) => x.Id == item.StatusId);

    if (s) {
      return s.Name;
    }

    return null;
  };

  const getFirstTag = (item: IDossierItem) => {
    if (!item.TagIds || item.TagIds.length === 0) return null;

    const t = tags.find((x) => x.Id == item.TagIds[0]);

    if (t) {
      return t.Name;
    }

    return null;
  };

  // useEffect(() => {
  //   setDossierFiles(dossierData?.data?.Items ?? []);
  // }, [dossierData?.data]);

  // Jedna firma na użytkownika, bez przełącznika kontekstu (decyzja D1) — nie ma już
  // zdarzenia "zmiana firmy" w trakcie sesji, więc refetch po takiej zmianie jest zbędny
  // (pierwsze pobranie robi dataSource; ten efekt nigdy by się nie odpalił drugi raz).

  const [showDelete, setShowDelete] = useState(false);

  // const ObjectKeys = useMemo(
  //   () => dossierData?.data.ObjectKeys ?? [],
  //   [dossierData]
  // );
  // const ParentKeys = useMemo(() => dossierData?.data.Keys ?? [], [dossierData]);
  // const k = useMemo(() => dossierData?.data.Keys ?? [], [dossierData]);

  const fileInputRef = useRef<HTMLInputElement>(null);

  // useEffect(() => {
  //   if (!dossierData?.data) return;
  //   const a = [k as IKey[], ObjectKeys as IKey[], ParentKeys as IKey[]].flat();
  //   // @ts-ignore
  //   setKeys((prev) => [...prev, ...a]);
  //   console.log("Keys updated, added", a);
  // }, [ObjectKeys, ParentKeys, k, dossierData]);

  const [sortModel, setSortModel] = useState<GridSortModel>(
    caseId
      ? [
          {
            field: GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
            sort: "asc",
          },
        ]
      : [
          {
            field: "LastOpened",
            sort: "desc",
          },
        ],
  );

  useEffect(() => {
    if (createFolderOnInit) {
      setTimeout(() => {
        handleCreateFolder();
        setCreateFolderOnInit(false);
      }, 1000);
    }
  }, [createFolderOnInit]);

  const onDrop = async (filesToUpload: any[]) => {
    const dossierObjects: IDossierItem[] = [];
    for (const f of filesToUpload) {
      const dossierObject = createDossierObject(
        randomString(),
        f.name,
        f.type,
        f.size,
        null,
        undefined,
        DossierItemType.Attachment,
      );

      dossierObjects.push(dossierObject);
    }

    //setDossierFiles([...dossierFiles, dossierObjects].flat());
    apiRef.current.dataSource.cache.clear();
    const rows = Object.values(
      gridRowsLookupSelector(apiRef),
    ) as IDossierItem[];
    const toAdd = dossierObjects.map((x) => ({ id: x.DossierId, ...x }));

    const folders = rows.filter((x) => x.Type === DossierItemType.Folder);
    const other = rows.filter((x) => x.Type !== DossierItemType.Folder);

    apiRef.current.setRows([...folders, ...toAdd, ...other]);

    let ownerKey: openpgp.key.KeyResult = null;

    if (key) {
      const casePublicKeyData = await readFileFromBase64(
        key.PublicKey,
        "application/other",
      );

      ownerKey = await openpgp.key.read(new Uint8Array(casePublicKeyData));
      console.log("Case public key", ownerKey);
    } else {
      const myKeys = await getKeys(userId);
      const masterPublicKey = await readFileFromBase64(
        myKeys!.publicBase64Key,
        "application/other",
      );
      const armored = new TextDecoder().decode(masterPublicKey);

      ownerKey = await openpgp.key.readArmored(armored);
    }

    let index = 0;
    const uploadedFiles = [];
    for (const f of filesToUpload) {
      setDownloadId(dossierObjects[index].Id);
      const r = await handleCreate(
        [f],
        Case?.Id,
        ownerKey,
        true,
        true,
        undefined,
        undefined,
        (fileIndex: number, progress: number) => setDownloadProgress(progress),
      );

      uploadedFiles.push(r);
      index++;
    }

    addFileToDossier(
      {
        CaseId: Case!.Id!,
        //@ts-ignore
        Files: uploadedFiles.map((ff: any) => {
          return {
            KeyId: ff[0].keyId,
            Uri: ff[0].uri,
          };
        }),
        ParentId: null,
      },
      {
        onSuccess: () => {
          setDownloadId(null);
          refetch();
        },
      },
    );
  };

  const [{ isOver: isDropOver, canDrop }, dropRef] = useDrop({
    accept: [NativeTypes.FILE],
    drop(item: { files: any[] }) {
      logger.log("Drop explorer file");
      if (onDrop) {
        onDrop(item.files);
      }
    },
    collect: (monitor: DropTargetMonitor) => {
      const item = monitor.getItem() as any;
      if (item) {
        console.log("collect", item.files, item.items);
      }

      return {
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      };
    },
  });

  const CustomRowWrapper = ({ row, index, ...rest }) => {
    const rowStyle = {
      padding: "8px",
      margin: "4px 0",
      backgroundColor: "red",
      border: "5px solid black",
    };

    const onDrop = (d) => {
      //dropGlobal(itemId, d.id);
      const movedRow = apiRef.current.getRow(d.id) as IDossierItem;

      console.log("Drop", d, movedRow);

      if (movedRow) {
        if (movedRow.DossierId === row.DossierId) {
          return;
        }
        moveFile(movedRow.DossierId, 99, row.DossierId).then(() => {
          //setDossierFiles([...dossierFiles, dossierObjects].flat());
          //apiRef.current.dataSource.cache.clear();

          const rows = Object.values(
            gridRowsLookupSelector(apiRef),
          ) as IDossierItem[];
          //var movedRow = rows.find((x) => x.DossierId === movedRow.DossierId);
          const newParent = rows.find((x) => x.DossierId === row.DossierId);
          //var newParentIndex = rows.findIndex((x) => x.DossierId === row.DossierId);

          //var newRows = rows.filter((x) => x.DossierId !== movedRow.DossierId);
          newParent.ChildrenCount++;

          movedRow.ParentId = newParent.DossierId;
          //apiRef.current.updateRows([movedRow]);
          apiRef.current?.updateRows([
            { id: movedRow.DossierId, _action: "delete" },
          ]);
          //console.log("moved row", movedRow);
          //apiRef.current.setRows(newRows);

          // console.log('Old rows', rows);
          // console.log('New rows', newRows);
          apiRef.current.dataSource.fetchRows(row.DossierId, {
            skipCache: true,
            keepChildrenExpanded: true,
          });
          // apiRef.current.setRowPosition(
          //   rowData.DossierId,
          //   row.DossierId,
          //   "inside"
          // );
          // reload
          //setDossierFiles(newFiles.filter((x) => x.Id !== f.Id));
        });
      }
    };

    const [{ isOver }, drop] = useDrop({
      accept: row?.Type === DossierItemType.Folder ? ["attachment"] : "none",
      drop: onDrop,
      canDrop: (i) => {
        if (i.id === row.id) return false;
        return true;
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    });

    const [, dragRef] = useDrag(
      () => ({
        type: "attachment",
        canDrag: () => true,
        item: { id: row?.id },
        collect: (monitor) => ({
          opacity: monitor.isDragging() ? 0.5 : 1,
        }),
        // isDragging: (monitor) => {
        //   var itemId = monitor.getItem().id;

        //   const clientOffset = monitor.getClientOffset();

        //   if (clientOffset) {
        //     var el = wrapperRef.current as HTMLElement;
        //     var elRect = el.getBoundingClientRect();
        //     if (elRect) {
        //       // Get pixels to the top
        //       const hoverClientY = clientOffset.y - elRect.top;

        //       if (hoverClientY < 200) {
        //         var currentScroll = apiRef.current.getScrollPosition();

        //         apiRef.current.scroll({
        //           top: currentScroll.top - 10,
        //         });
        //       }
        //     }
        //   }

        //   return row?.id === itemId;
        // },
      }),
      [],
    );

    return (
      <div
        ref={drop}
        className={classNames(
          isOver ? styles.rowOver : null,
          row.menu ? styles.rowMenu : null,
        )}
      >
        <div ref={dragRef} className={styles.rowWrapper}>
          <GridRow
            index={index}
            row={row}
            cell
            {...rest}
            style={{
              opacity:
                cutting &&
                copyElements &&
                copyElements.find((x) => x.DossierId === row?.DossierId)
                  ? 0.5
                  : 1.0,
            }}
            sx={{
              ...rowStyle,
            }}
          ></GridRow>
          <div className={styles.progressBar}>
            {(row?.Id === downloadId || row?.DossierId === downloadId) && (
              <LinearProgress
                variant={downloadProgress > 0 ? "determinate" : "indeterminate"}
                value={downloadProgress ?? 0}
              />
              // <div
              //   style={{ width: `${downloadProgress ?? 0}%` }}
              //   className={styles.progress}
              // ></div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const wrapperRef = useRef(null);

  // useKeyPressEvent("c", (e) => {
  //   if (e.ctrlKey && activePanel === "right" && !isInputFocused()) {
  //     handleCopy(false);
  //   }
  // });

  // useKeyPressEvent("x", (e) => {
  //   if (e.ctrlKey && activePanel === "right" && !isInputFocused()) {
  //     handleCopy(true);
  //   }
  // });

  // useKeyPressEvent("v", (e) => {
  //   if (e.ctrlKey && activePanel === "right" && !isInputFocused()) {
  //     handlePaste();
  //   }
  // });

  const updateRowEditMode = (
    id: string,
    editMode: boolean,
    newLabel?: string,
  ) => {
    const rows = Object.values(
      gridRowsLookupSelector(apiRef),
    ) as IDossierItem[];

    const toUpdate = rows.find((x) => x.DossierId === id);

    if (toUpdate) {
      toUpdate.editLabel = editMode;

      if (newLabel) {
        toUpdate.Label = newLabel;
      }

      apiRef.current.updateRows([{ id: id, Label: newLabel }]);
    }
  };

  useKeyPressEvent("F2", () => {
    if (selectedItems && selectedItems.length > 0) {
      updateRowEditMode(selectedItems[0].DossierId, true);
    }
  });

  useKeyPressEvent("Enter", () => {
    if (selectedItems.length > 0) {
      const selected = selectedItems[0];

      if (selected.Kind === ItemKind.DossierFolder) {
        onFolderDoubleClick(selected);
      } else {
        handleFileDoubleClick(selected);
      }
    }
  });

  const handleFileDoubleClick = (file: IDossierItem) => {
    if (
      file?.Type === DossierItemType.Link ||
      file?.Type === DossierItemType.GoogleDocs
    ) {
      window.open(file.Link, "_blank");
      return;
    }

    apiRef.current.updateRows([{ id: file.DossierId, LastOpened: new Date() }]);

    if (previewInModal) {
      setPreviewItem(file);
      setShowPreview(true);
      return;
    }

    const isFullscreen = window.location.href.search("fullscreen") !== -1;

    let newUrl = `${window.location.pathname}?pdf=${file.Id}:${
      file.SignedPdfUri
        ? `${file.FileName.replace(":", "")}.pdf`
        : file.FileName.replace(":", "")
    }:${file.SignedPdfUri ?? file.FileUri}:${file.Kind}:${
      file.EncryptionKeyId
    }`;
    if (isFullscreen) {
      newUrl += "&fullscreen=1";
    }

    navigate(newUrl);

    return;
  };

  const moveFile = (
    elementId: string,
    order: number,
    folderId: string | null,
  ) => {
    return new Promise((resolve) => {
      moveDossier(
        {
          Id: elementId,
          Order: order,
          ParentId: folderId,
        },
        {
          onSuccess: () => {
            resolve(true);
          },
        },
      );
    });
  };

  // useEffect(() => {
  //   window.addEventListener("keydown", handleKeyDown);
  //   window.addEventListener("keyup", handleKeyUp);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //     window.removeEventListener("keyup", handleKeyUp);
  //   };
  // }, [can, selectedFiles]);

  const { mutate: addFileToDossier } = dossierService.useAddFile();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const PDFId = queryParams.get("pdf");

  const auth = useAuth();
  const userId = getUserId(auth.user!);

  const onFolderDoubleClick = (folder: IDossierItem) => {
    if (folder.Type === DossierItemType.Case) {
      setPreviewItem(folder);
      setShowPreviewCase(true);
      return;
    }

    if (previewInModal) {
      setPreviewItem(folder);
      setShowFolderPreview(true);
    } else {
      const isFullscreen = window.location.href.search("fullscreen") !== -1;

      const newUrl = `/cases/${caseId}/dossier/f/${folder.DossierId}`;

      const query = new URLSearchParams(window.location.search);

      if (PDFId && !query.get("pdf")) {
        query.append("pdf", PDFId);
      }

      if (isFullscreen && !query.get("fullscreen")) {
        query.append("fullscreen", "1");
      }

      // if (isFullscreen) {
      //   newUrl += "?fullscreen=1";
      // }

      navigate(`${newUrl}?${query}`);
      setCurrentFolderToCaseView?.(folder);
    }
  };

  const navigateToRoot = () => {
    if (caseId) {
      navigate(`/cases/${caseId}/dossier`);
    }
    setCurrentFolderToCaseView?.(null);
  };

  // useEffect(() => {
  //   logger.log("Selected files", selectedFiles);
  //   onSelecting?.(selectedFiles);
  // }, [selectedFiles]);

  const handleAddNewFilesToDossier = async (
    elements: IDossierItem[],
    c: ICase,
  ) => {
    const newDossierElements = [...dossierFiles];
    for (const element of elements) {
      const sameFolder = element.ParentId == selectedFolder?.Id;

      if (sameFolder) {
        element.Id = `${element.Id}_copy`;
      }

      newDossierElements.push(
        createDossierObject(
          element.Id,
          sameFolder
            ? addCopyToFileName(element.FileName ?? "")
            : element.FileName,
          element.FileContentType,
          element.FileSize,
          element.ParentId,
          element.Label,
          element.Type,
        ),
      );
    }

    setDossierFiles(newDossierElements.flat());

    for (const element of elements) {
      if (element.Kind != ItemKind.DossierFolder) {
        if (!element.FileUri) continue;

        const sameFolder = element.ParentId == selectedFolder?.Id;

        const file = await getFile(element.FileUri);
        const blob = await getBlob(file.data.Url);

        const key = keys.find(
          (key: any) => key?.Id === element.EncryptionKeyId,
        );

        if (!key) return;

        let parentKey = null;
        //@ts-ignore
        if (key.ParentKeyId) {
          parentKey = keys.find(
            //@ts-ignore
            (pkey: any) => pkey?.Id === key?.ParentKeyId,
          );
        }

        const decryptedFile = await decryptFile(
          userId ?? "",
          new Blob([blob.data]),
          key,
          parentKey,
        );

        setDownloadId(element.Id);

        const casePublicKeyData = await readFileFromBase64(
          key.PublicKey,
          "application/other",
        );

        const casePublicKey = await openpgp.key.read(
          new Uint8Array(casePublicKeyData),
        );

        const r = await handleCreate(
          [decryptedFile],
          Case!.Id,
          casePublicKey,
          true,
          true,
          sameFolder
            ? addCopyToFileName(element.FileName ?? "")
            : element.FileName,
          element.FileContentType,
          (fileIndex, progress) => {
            setDownloadProgress(progress);
          },
        );

        if (!r) {
          return;
        }

        let payload: IDossierAddFile = {
          CaseId: Case!.Id!,
          Files: [
            //@ts-ignore
            {
              KeyId: r[0].keyId,
              Uri: r[0].uri,
            },
          ],
        };

        if (selectedFolder) {
          payload = { ...payload, ParentId: selectedFolder.DossierId };
        }

        addFileToDossier(payload, {
          onSuccess: () => {
            setDownloadId(null);
            if (cutting) {
              deleteDossier({
                Id: element.DossierId,
              });
            }
          },
        });
      } else {
        if (cutting && Case!.Id! === c.Id) {
          await moveFile(element.Id, 0, selectedFolder?.Id ?? null);
        }
      }
    }
    sessionStorage.removeItem("copy_elements");
    sessionStorage.removeItem("copy_case");
    sessionStorage.removeItem("copy_folder");
    sessionStorage.removeItem("copy_cut");
    setCopyCase(null);
    setCopyElements([]);
    setCutting(false);
    refetch();
  };

  const [cutting, setCutting] = useState(
    JSON.parse(sessionStorage.getItem("copy_cut") ?? false),
  );

  const handleCopy = (remove: boolean, items?: IDossierItem[]) => {
    sessionStorage.setItem(
      "copy_elements",
      JSON.stringify(items ?? selectedItems),
    );
    sessionStorage.setItem("copy_case", JSON.stringify(Case));
    sessionStorage.setItem("copy_folder", JSON.stringify(selectedFolder));
    sessionStorage.setItem("copy_cut", remove.toString());

    setCutting(remove);

    notification({
      type: ENotificationType.INFO,
      text: t("dossier.copiedToClipboard"),
      title: t("dossier.copied"),
    });
    setCopyElements(items ?? selectedItems);
    setCopyCase(Case!);
    setSelectedItems([]);
  };

  useEffect(() => {
    console.log("Selected items", selectedItems);
  }, [selectedItems]);

  const handlePaste = async () => {
    const elements = sessionStorage.getItem("copy_elements");
    const sourceCase = sessionStorage.getItem("copy_case");
    const sourceFolder = sessionStorage.getItem("copy_folder");

    if (elements?.length) {
      const converted: IDossierItem[] = JSON.parse(elements);
      const c: ICase = JSON.parse(sourceCase!);
      const f: IDossierItem = JSON.parse(sourceFolder!);

      if (cutting && c.Id === Case.Id && f?.Id !== selectedFolder.Id) {
        for (const element of converted) {
          await moveFile(element.DossierId, 0, selectedFolder?.DossierId);
        }

        sessionStorage.removeItem("copy_elements");
        sessionStorage.removeItem("copy_case");
        sessionStorage.removeItem("copy_folder");
        sessionStorage.removeItem("copy_cut");
        setCopyCase(null);
        setCopyElements([]);
        setCutting(false);
        refetch();
      } else {
        handleAddNewFilesToDossier(converted!, c);
      }
    }
  };

  const handleAttachToDesk = () => {};

  const handleDelete = () => {
    const ask = localStorage.getItem("ask");

    if (ask === "true") {
      deleteInternal();
      return;
    }

    setShowDelete(true);
  };

  const deleteInternal = () => {
    for (const f of selectedItems) {
      deleteDossier(
        {
          Id: f.DossierId,
        },
        {
          onSuccess: () => {
            setDossierFiles((old) =>
              old.filter((x) => x.DossierId != f.DossierId),
            );
          },
        },
      );
    }
  };

  const handleCreateEditorDocument = (format: string) => {
    if (isPluginError) {
      setShowPluginError(true);
    } else {
      setOptions({ format: format, callback: afterCreated });
      setModals({ ...defaultValue, createLetter: true, hide: false });
    }
  };

  const afterCreated = () => {
    refetch();
  };

  const [copyElements, setCopyElements] = useState<IDossierItem[]>(
    JSON.parse(sessionStorage.getItem("copy_elements") ?? "[]"),
  );
  const [copyCase, setCopyCase] = useState<ICase | null>(
    JSON.parse(sessionStorage.getItem("copy_case") ?? "[]"),
  );

  const [copyFolder] = useState<IDossierItem | null>(
    JSON.parse(sessionStorage.getItem("copy_folder") ?? "[]"),
  );

  const showCopyMenu = !!selectedItems.length;
  const showCopyOptions =
    showCopyMenu && (!copyCase?.Id || copyCase?.Id === Case?.Id);
  const showPasteOptions =
    !!copyElements.length &&
    (copyCase?.Id !== Case?.Id || copyFolder?.Id !== selectedFolder?.Id);
  const clearClipboard = () => {
    sessionStorage.removeItem("copy_elements");
    sessionStorage.removeItem("copy_case");
    sessionStorage.removeItem("copy_folder");
    sessionStorage.removeItem("copy_cut");
    setCopyCase(null);
    setCopyElements([]);
    setCutting(false);
  };

  const fetchNextPage = () => {};

  const handleCreateFolder = () => {
    let parentId: string = undefined;

    const newRow: IDossierItem = {
      id: "newFolder",
      Id: "newFolder",
      Type: DossierItemType.Folder,
      Kind: ItemKind.DossierFolder,
      DossierId: "newFolder",
      CreationDate: new Date(),
      LastModified: new Date(),
      TagCount: 0,
      CommentsCount: 0,
      IsShared: false,
      DeskInfo_IsOn: false,
      Keys: [],
      ObjectKeys: [],
    };

    apiRef.current.dataSource.cache.clear();

    const rows = Object.values(
      gridRowsLookupSelector(apiRef),
    ) as IDossierItem[];

    if (
      selectedItems &&
      selectedItems.find((x) => x.Type === DossierItemType.Folder)
    ) {
      parentId = selectedItems.find(
        (x) => x.Type === DossierItemType.Folder,
      ).id;

      console.log("New folder, parent id:", parentId);

      newRow.ParentId = parentId;
      const newParent = rows.find((x) => x.DossierId === parentId);
      const newParentIndex = rows.findIndex((x) => x.DossierId === parentId);

      // apiRef.current.dataSource
      //   .fetchRows(parentId, {
      //     keepChildrenExpanded: true,
      //   })
      //   .then((r) => {
      rows.splice(newParentIndex + 1, 0, newRow);
      newParent.ChildrenCount++;
      apiRef.current.setRows(rows);
      //   });
    } else {
      apiRef.current.setRows([newRow, ...rows]);
    }
  };

  const apiRef = useGridApiRef();

  // useEffect(() => {
  //   var newFolder = dossierFiles.find((d) => d.Id === "newFolder");

  //   if (newFolder && apiRef.current) {
  //     var mode = apiRef.current.getCellMode(newFolder.Id, "Label");
  //     if (mode === "view") {
  //       setTimeout(() => {
  //         apiRef.current.startCellEditMode({
  //           id: newFolder.Id,
  //           field: "Label",
  //         });
  //       }, 500);
  //     }
  //   }
  // }, [dossierFiles, apiRef.current]);

  const toolbar = () => (
    <>
      {!hideToolbar && (
        <CustomToolbar2
          setGroup={() => {}}
          group={false}
          showCreateMenu={showCreateMenu}
          handleCreateFolder={handleCreateFolder}
          setShowCreateMenu={setShowCreateMenu}
          caseId={caseId}
          setModals={setModals}
          handleCreateEditorDocument={handleCreateEditorDocument}
          currentFolder={null}
          folder={folder}
          folderData={null}
          isLoading={false /* todo */}
          navigateToRoot={navigateToRoot}
          onlyDesk={onlyDesk}
          hideCreate={hideCreate}
          isTrash={isTrashView}
          onEmptyTrash={() => setShowEmptyTrash(true)}
          statusId={filterStatusId}
          setStatusId={setFilterStatusId}
          tagId={filterTagId}
          setTagId={setFilterTagId}
          setEditFilter={setEditFilter}
          editFilter={editFilter}
          showSearch={true}
          searchText={searchText2}
          setSearchText={setSearchText2}
        ></CustomToolbar2>
      )}
    </>
  );

  const cellRef = useRef<HTMLDivElement>();

  const customEdit = ({ id, row }) => {
    const [name, setName] = useState<string>(row.Label);

    const commitValue = (v: string) => {
      setName(v);
      if (id === "newFolder") {
        createFolder({
          CaseId: caseId,
          Name: v,
          ParentId: row.ParentId,
        }).then(() => {
          refetch();
        });
      } else {
        commitLabel(id, v);
      }
    };

    const cancel = () => {
      console.log("Cancel", id);
      // api.stopCellEditMode({
      //   id,
      //   field,
      //   ignoreModifications: true,
      // });

      if (id === "newFolder") {
        apiRef.current.dataSource.cache.clear();
        apiRef.current.updateRows([{ id: "newFolder", _action: "delete" }]);
      } else {
        updateRowEditMode(id, false);
      }
    };

    return (
      <div className={styles.editCellWrapper}>
        <div className={styles.editCell} ref={cellRef}>
          <InputInline
            value={name}
            onChange={(v) => commitValue(v)}
            placeholder={
              id === "newFolder" ? t("dossier.newFolder") : row.FileName
            }
            smallButtons={true}
            withoutBackground={true}
            onCancel={cancel}
          ></InputInline>
        </div>
        {/* {hasFocus && row.Type === DossierItemType.Folder && (
          <Popper
            open={true}
            setOpen={() => {
              api.stopCellEditMode({
                id,
                field,
                ignoreModifications: true,
              });
            }}
            anchorEl={apiRef.current.getCellElement(id, field)}
            placement="bottom-start"
          >
            <div className={styles.dropdown}>
              {tagsData?.data
                .filter((x) => x.Type === TagType.Folder)
                .map((t) => (
                  <div
                    key={t.Id}
                    className={styles.itm}
                    onMouseDown={() => {
                      console.log("Click");
                      apiRef.current.setEditCellValue({
                        id,
                        field,
                        value: t.Name,
                      });
                      api.stopCellEditMode({
                        id,
                        field,
                        ignoreModifications: false,
                      });
                    }}
                  >
                    {t.Name}
                  </div>
                ))}
            </div>
          </Popper>
        )} */}
      </div>
    );
  };

  const CustomGridTreeDataGroupingCell = (props: GridRenderCellParams) => {
    const { id, rowNode } = props;
    const apiRef = useGridApiContext();

    const handleClick = () => {
      if (rowNode.type !== "group") {
        return;
      }

      if (!rowNode.childrenExpanded) {
        console.log("Fetching children", id);
        apiRef.current.dataSource.fetchRows(id);
        // apiRef.current.setRowChildrenExpansion(id, true);
        //apiRef.current.selectRow(id, false, true);
      } else {
        console.log("Collapsing", id);
        // apiRef.current?.dataSource.fetchRows(id, {
        //   keepChildrenExpanded: false,
        // });
        apiRef.current.setRowChildrenExpansion(id, false);

        //apiRef.current.
      }
    };

    if (id === "newFolder") {
      return customEdit({ ...props, field: "Label" });
    }

    if (props.row?.editLabel) {
      return customEdit({ ...props, field: "Label" });
    }

    return (
      <Box
        sx={{
          ml: rowNode.depth * 6,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {id === "newFolder" && <div>edit</div>}

        {(rowNode.type === "group" || props.row.ChildrenCount > 0) && (
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              handleClick();
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            {!rowNode.childrenExpanded ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        )}
        {rowNode.type !== "group" &&
          props.row.Type === DossierItemType.Folder && (
            <div className={styles.spaceTaker}></div>
          )}
        <NameCell element={props.row}></NameCell>
      </Box>
    );
  };

  const groupingColDef: DataGridPremiumProps["groupingColDef"] = {
    headerName: t("columns.name"),
    renderCell: (params) => <CustomGridTreeDataGroupingCell {...params} />,
    minWidth: 120,
    flex: 1,
    sortable: true,
  };

  const [contextMenu, setContextMenu] = useState<IContextMenu>(null);

  const dossierColumns = [
    // {
    //   field: "Category",
    //   headerName: "Rodzaj",
    //   cellClassName: `${styles.nameCell}`,
    //   valueGetter: (value, row) => getDossierItemGroupName(row),
    // },
    // {
    //   field: "Label",
    //   minWidth: 280,
    //   flex: 1,
    //   headerName: "Nazwa",
    //   cellClassName: `${styles.nameCell}`,
    //   renderCell: (params: GridRenderCellParams<any, string>) =>
    //     params.rowNode.type !== "group" ? (
    //       <NameCell element={params.row}></NameCell>
    //     ) : (
    //       <NameCell element={params.row}></NameCell>
    //     ),
    //   renderEditCell: (params: GridRenderEditCellParams) => customEdit(params),
    //   editable: true,
    //   valueGetter: (value, row) => row.Label ?? row.FileName,
    //   groupingValueGetter: (value, row) => getDossierItemGroupName(row),
    // },
    {
      field: "FileSize",
      width: 100,
      headerName: t("columns.size"),
      headerAlign: "center",
      align: "center",
      groupable: false,
      sortable: false,
      cellClassName: `${styles.sizeCell}`,
      renderCell: (params: GridRenderCellParams<any, number>) =>
        params.rowNode.type !== "group"
          ? params.row.Kind != ItemKind.DossierLink &&
            params.row.Kind != ItemKind.DossierFolder &&
            params.row.FileSize !== null &&
            params.row.FileSize !== -1
            ? prettyBytes(params.row.FileSize ?? 0)
            : ""
          : null,
    },
    {
      field: "State",
      width: 140,
      headerName: t("columns.status"),
      headerAlign: "center",
      align: "center",
      sortable: false,
      cellClassName: `${styles.statusCell}`,
      valueGetter: (value, row) => getStatus(row),
      groupingValueGetter: (value, row) =>
        getStatus(row) ?? t("dossier.noStatus"),
      sortComparator: nullHandlingSortComparator,
      groupable: false,
      renderCell: (params: GridRenderCellParams<any, number>) =>
        params.rowNode.type !== "group" ? (
          <StatusCell
            element={params.row}
            statuses={statuses}
            apiRef={apiRef}
          ></StatusCell>
        ) : (
          <div>{params.value}</div>
        ),
    },
    {
      field: "TagIds",
      width: 140,
      headerName: t("columns.label"),
      headerAlign: "center",
      align: "center",
      groupable: false,
      sortable: false,
      cellClassName: `${styles.tagCell}`,
      valueGetter: (value, row) => getFirstTag(row),
      groupingValueGetter: (value, row) =>
        getFirstTag(row) ?? t("dossier.noLabel"),
      sortComparator: nullHandlingSortComparator,
      renderCell: (params: GridRenderCellParams<any, number>) =>
        params.rowNode.type !== "group" ? (
          <TagCell element={params.row} tags={tags} apiRef={apiRef}></TagCell>
        ) : (
          <div>{params.value}</div>
        ),
    },

    {
      field: "CreationDate",
      width: 100,
      headerName: t("columns.createdDate"),
      hide: true,
      groupable: false,
      valueGetter: (value, row) => row?.CreationDate,
      valueFormatter: (v) => {
        if (v) {
          return moment(v).format("DD.MM.yyyy");
        }
        return "";
      },
    },
    {
      field: "LastModified",
      width: 100,
      headerName: t("columns.modifiedDate"),
      hide: true,
      groupable: false,
      valueGetter: (value, row) => row?.LastModified,
      valueFormatter: (v) => {
        if (v) {
          return moment(v).format("DD.MM.yyyy");
        }
        return "";
      },
    },

    {
      field: "LastOpened",
      width: 110,
      groupable: false,
      headerName: t("columns.openedDate"),
      renderHeader: () => {
        return (
          <div className={styles.colheader}>{t("columns.openedDateShort")}</div>
        );
      },
      hide: true,
      valueGetter: (value, row) => row?.LastOpened,
      valueFormatter: (v) => {
        if (v) {
          return moment(v).format("DD.MM.yyyy");
        }
        return "";
      },
    },

    {
      field: "Icons",
      width: 150,
      headerName: "",
      disableReorder: true,
      disableColumnMenu: true,
      sortable: false,
      groupable: false,
      cellClassName: `${styles.iconsCell}`,

      renderCell: (params: GridRenderCellParams<any, number>) =>
        params.rowNode.type !== "group" ? (
          <IconsCell
            element={params.row}
            caseId={caseId}
            isDesk={onlyDesk}
          ></IconsCell>
        ) : null,
    },

    {
      field: "Menu",
      width: 40,
      headerName: "",
      disableReorder: true,
      disableColumnMenu: true,
      sortable: false,
      groupable: false,
      cellClassName: `${styles.iconsCell}`,

      renderCell: (params: GridRenderCellParams<any, number>) => (
        <MenuCell
          element={params.row}
          caseId={caseId}
          parentKeys={[] /* todo parentKeys*/}
          handleFileDoubleClick={handleFileDoubleClick}
          refetchAll={refetch}
          apiRef={apiRef}
          handleCreateVersion={(i) => {
            setActiveElement(i);
            setShowCreateVersion(true);
          }}
          handleMove={(i) => {
            setActiveElement(i);
            setShowMove(true);
          }}
          handleShare={(i) => {
            setActiveElement(i);
            setShowShare(true);
          }}
          menuOnly={false}
          isTrash={isTrashView}
          handleCopy={(e) => {
            handleCopy(false, [e]);
          }}
          handleCut={(e) => {
            handleCopy(true, [e]);
          }}
        ></MenuCell>
      ),
    },
  ];

  const [, setExpansionDepth] = useState<number>(0);

  const memoColumns = useMemo<GridColDef[]>(
    () => dossierColumns,
    [tags, statuses],
  );

  const slots = {
    toolbar: toolbar,
    row: CustomRowWrapper,
    columnHeaders: hideColumnHeader ? () => null : undefined,
    noRowsOverlay: () => <div></div>,
  };
  const slotsMemo = useMemo<Partial<GridPremiumSlotsComponent>>(
    () => slots,
    [toolbar],
  );

  const hiddenFields = [
    "Label",
    GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
    "Icons",
    "Menu",
  ];

  const getTogglableColumns = (columns: GridColDef[]) => {
    return columns
      .filter((column) => !hiddenFields.includes(column.field))
      .map((column) => column.field);
  };

  const [initialState, setInitialState] = useState<GridInitialState>(null);

  const initialStateHidden = useKeepGroupedColumnsHidden({
    apiRef,
    initialState,
  });

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>(null);

  // const [groupingModel, setGroupingModel] = useState<GridRowGroupingModel>([]);

  const saveSnapshot = useCallback(() => {
    if (apiRef?.current?.exportState && localStorage) {
      const currentState = apiRef.current.exportState();
      localStorage.setItem("grid_caseDossier2", JSON.stringify(currentState));
    }
  }, [apiRef]);

  // const [rowSelectionModel, setRowSelectionModel] =
  //   useState<GridRowSelectionModel>([]);

  // useEffect(() => {
  //   if (miniMode) {
  //     setGroup(false);
  //     return;
  //   }
  //   const stateFromLocalStorage = localStorage?.getItem(
  //     "grid_caseDossier_group"
  //   );

  //   if (stateFromLocalStorage) {
  //     setGroup(JSON.parse(stateFromLocalStorage));
  //   }
  // }, []);

  useEffect(() => {
    setSelectedItems([]);
  }, []);

  useEffect(() => {
    console.log("Column visibility model changed", columnVisibilityModel);
  }, [columnVisibilityModel]);

  useLayoutEffect(() => {
    const stateFromLocalStorage = localStorage?.getItem("grid_caseDossier2");
    if (!miniMode) {
      const state = JSON.parse(stateFromLocalStorage);

      const data: GridInitialStatePremium = stateFromLocalStorage
        ? state
        : ({} as GridInitialStatePremium);

      setInitialState(data);
      initialStateHidden.columns = data.columns;
      //initialStateHidden.rowGrouping = data.rowGrouping;
      //setGroupingModel(data.rowGrouping?.model ?? []);

      console.log("Setting initial state", state);
      setInitialState(
        stateFromLocalStorage
          ? state
          : {
              columns: {
                columnVisibilityModel: {
                  Category: false,
                  LastModified: false,
                  CreationDate: false,
                },
              },
            },
      );

      if (state) {
        setColumnVisibilityModel((old) => {
          return {
            ...old,
            Category: false,
            LastModified:
              state?.columns?.columnVisibilityModel?.LastModified ?? true,
            CreationDate:
              state?.columns?.columnVisibilityModel?.CreationDate ?? true,
            LastOpened:
              state?.columns?.columnVisibilityModel?.LastOpened ?? true,
            TagIds: state?.columns?.columnVisibilityModel?.TagIds ?? true,
            State: state?.columns?.columnVisibilityModel?.State ?? true,
            Size: state?.columns?.columnVisibilityModel?.Size ?? true,
          };
        });
      } else {
        setColumnVisibilityModel({
          Category: false,
          State: !miniMode,
          TagIds: !miniMode,
        });
      }
    } else {
      setInitialState(
        stateFromLocalStorage
          ? JSON.parse(stateFromLocalStorage)
          : {
              columns: {
                columnVisibilityModel: {
                  Category: false,
                  State: false,
                  TagIds: false,
                },
              },
            },
      );
      setColumnVisibilityModel((old) => {
        return {
          ...old,
          Category: false,
          LastModified: false,
          CreationDate: false,
          State: false,
          TagIds: false,
        };
      });
    }

    // handle refresh and navigating away/refreshing
    window.addEventListener("beforeunload", saveSnapshot);

    return () => {
      // in case of an SPA remove the event-listener
      window.removeEventListener("beforeunload", saveSnapshot);
      saveSnapshot();
    };
  }, [saveSnapshot]);

  const handleRowContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    if (!event.currentTarget) {
      return;
    }
    const rowId = (event.currentTarget as HTMLDivElement).getAttribute(
      "data-id",
    );

    const record = dossierFiles.find((row) => row.DossierId === rowId);

    if (!record) {
      return;
    }

    logger.log("Showing context menu", record);

    setContextMenu(
      contextMenu === null
        ? { X: event.clientX, Y: event.clientY, Item: record }
        : null,
    );
  };

  const handleRowDoubleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    if (!event.currentTarget) {
      return;
    }
    const rowId = (event.currentTarget as HTMLDivElement).getAttribute(
      "data-id",
    );

    const record = apiRef.current.getRow(rowId);

    if (!record) {
      return;
    }

    if (record?.Type === DossierItemType.Folder) {
      onFolderDoubleClick(record);
    } else {
      handleFileDoubleClick(record);
    }
  };

  if (
    !initialState ||
    !columnVisibilityModel ||
    !initialStateHidden ||
    isTagsLoading ||
    isStatusesLoading
  ) {
    return <CircularProgress />;
  }

  return (
    <>
      <div
        ref={wrapperRef}
        className={`${styles.wrapper} ${className} ${
          !dossierFiles.length && !dossierFiles.length ? styles.empty : ""
        } ${caseId ? styles.empty : styles.main} ${
          onlyDesk ? styles.inDesk : null
        }`}
      >
        <div className={styles.row}>
          {(selectedItems.length > 1 || showPasteOptions) &&
            !isDossierLoading &&
            !isOutcoming && (
              <div className={styles.options}>
                {selectedItems.length > 0 && (
                  <div className={styles.counter}>
                    {t("dossier.selected", { count: selectedItems.length })}
                  </div>
                )}
                {showPasteOptions && copyElements?.length === 1 && (
                  <div className={styles.counter}>
                    {t("dossier.clipboardOne", { count: copyElements?.length })}
                  </div>
                )}
                {showPasteOptions &&
                  copyElements?.length > 1 &&
                  copyElements?.length < 5 && (
                    <div className={styles.counter}>
                      {t("dossier.clipboardFew", {
                        count: copyElements?.length,
                      })}
                    </div>
                  )}
                {showPasteOptions && copyElements?.length > 4 && (
                  <div className={styles.counter}>
                    {t("dossier.clipboardMany", {
                      count: copyElements?.length,
                    })}
                  </div>
                )}
                <div className={styles.buttons}>
                  {showCopyOptions && (
                    <>
                      <CutIcon
                        title={t("common.cut")}
                        onClick={() => handleCopy(true)}
                      />
                      <CopyIcon
                        title={t("common.copy")}
                        onClick={() => handleCopy(false)}
                      />
                    </>
                  )}
                  {showPasteOptions && (
                    <CopyIcon title={t("common.paste")} onClick={handlePaste} />
                  )}
                  {selectedItems.filter((x) => x.Kind != ItemKind.DossierFolder)
                    .length > 0 && (
                    <DeskIcon
                      title={t("dossier.pinToDesk")}
                      onClick={handleAttachToDesk}
                    />
                  )}
                  {selectedItems.length > 1 && (
                    <DeleteIcon
                      title={t("common.delete")}
                      onClick={handleDelete}
                    />
                  )}
                </div>
                <CloseIcon
                  className={styles.close}
                  onClick={() => {
                    setSelectedItems([]);
                    clearClipboard();
                  }}
                />
              </div>
            )}
        </div>
        <div
          className={classNames(
            styles.content,
            !isDossierLoading && dossierFiles.length === 0 ? styles.empt : null,
          )}
          ref={dropRef}
        >
          {onlyDesk && !isDossierLoading && dossierFiles.length === 0 && (
            <div className={styles.empty}>
              <NotFoundScreen
                size="medium"
                title={t("dossier.deskEmpty")}
                text={t("dossier.deskEmptyText")}
                buttonName={t("dossier.addFileFolder")}
                onClick={() => setModals({ ...modals, createDossier: true })}
              />
            </div>
          )}
          {(!onlyDesk || dossierFiles.length > 0) && (
            <DataGridPremium
              apiRef={apiRef}
              disableRowSelectionOnClick
              rowSelectionModel={selectedRowIds}
              onRowClick={handleRowClick}
              dataSource={dataSource}
              dataSourceCache={null}
              //lazyLoading
              // treeData={!groupingModel || groupingModel.length === 0}
              treeData
              onColumnVisibilityModelChange={(m) => {
                console.log("ON Column visibility model changed", m);
                setColumnVisibilityModel(m);
                setTimeout(() => saveSnapshot(), 1000);
              }}
              onColumnOrderChange={() => {
                setTimeout(() => saveSnapshot(), 1000);
              }}
              // onRowGroupingModelChange={(m, d) => {
              //   var newVisibility = { ...columnVisibilityModel };

              //   for (var i = 0; i < groupingModel.length; i++) {
              //     newVisibility[groupingModel[i]] = true;
              //   }

              //   for (var i = 0; i < m.length; i++) {
              //     newVisibility[m[i]] = false;
              //   }
              //   setColumnVisibilityModel(newVisibility);
              //   setGroupingModel(m);
              // }}
              showToolbar
              onPinnedColumnsChange={() => {
                setTimeout(() => saveSnapshot(), 1000);
              }}
              onColumnWidthChange={() => {
                setTimeout(() => saveSnapshot(), 1000);
              }}
              onRowSelectionModelChange={(newRowSelectionModel) => {
                setTimeout(() => {
                  const rows = Object.values(
                    gridRowsLookupSelector(apiRef),
                  ) as IDossierItem[];
                  setSelectedItems(
                    rows.filter((d) =>
                      newRowSelectionModel.ids.has(d.DossierId),
                    ),
                  );
                }, 250);
              }}
              //rowSelectionModel={rowSelectionModel}
              sx={{
                border: 0,
                "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                  outline: "none !important",
                },
                "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
                  {
                    outline: "none !important",
                  },
              }}
              slots={slotsMemo}
              slotProps={{
                loadingOverlay: {
                  variant: "skeleton",
                  noRowsVariant: "skeleton",
                },
                columnsManagement: {
                  getTogglableColumns,
                },
                row: {
                  onContextMenu: (e) => handleRowContextMenu(e),
                  onDoubleClick: (e) => handleRowDoubleClick(e),
                },
              }}
              localeText={plGridLocales}
              columnHeaderHeight={30}
              onCellEditStart={(
                params: GridCellEditStartParams,
                event: MuiEvent,
              ) => {
                if (
                  params.reason === GridCellEditStartReasons.cellDoubleClick
                ) {
                  event.defaultMuiPrevented = true;
                }
              }}
              processRowUpdate={async () => {
                // console.log("processing row update", updatedRow, originalRow);
                // var newCollection = [...dossierFiles];
                // if (originalRow.Id === "newFolder") {
                //   var result = await createFolder({
                //     CaseId: caseId,
                //     Name: updatedRow.Label,
                //     ParentId: currentFolder?.DossierId,
                //   });
                //   if (result.data) {
                //     var toUpdate = newCollection.find(
                //       (x) => x.Id === originalRow.Id
                //     );
                //     if (toUpdate) {
                //       console.log("New folder", toUpdate);
                //       var newCollection = [...dossierFiles];
                //       toUpdate.Label = updatedRow.Label;
                //       toUpdate.Id = result.data.Id;
                //       toUpdate.DossierId = result.data.Id;
                //       updatedRow.Id = result.data.Id;
                //       updatedRow.DossierId = result.data.Id;
                //       updatedRow.id = result.data.Id;
                //       setDossierFiles(newCollection);
                //     }
                //   }
                //   // {
                //   //   onSuccess(data, variables, context) {
                //   //     if (data.data) {
                //   //
                //   //     }
                //   return updatedRow;
                //   //   },
                // } else {
                //   commitLabel(originalRow.DossierId, updatedRow.Label);
                //   var toUpdate = newCollection.find(
                //     (x) => x.DossierId === originalRow.DossierId
                //   );
                //   if (toUpdate) {
                //     toUpdate.Label = updatedRow.Label;
                //     setDossierFiles(newCollection);
                //   }
                //   return updatedRow;
                // }
              }}
              onRowsScrollEnd={() => {
                fetchNextPage();
              }}
              initialState={{
                ...initialStateHidden,
                pagination: {
                  paginationModel: { pageSize: 100, page: 0 },
                },
                pinnedColumns: { right: ["Menu"] },
              }}
              // pinnedColumnsSectionSeparator="border-and-shadow"
              columnVisibilityModel={columnVisibilityModel}
              sortModel={sortModel}
              onSortModelChange={(newSortModel) => {
                logger.log("New sort model", newSortModel);
                setExpansionDepth(0);
                setSortModel(newSortModel);
              }}
              columns={memoColumns}
              hideFooter={true}
              disableColumnFilter={true}
              disableAggregation={true}
              disablePivoting={true}
              groupingColDef={groupingColDef}
              rowSelectionPropagation={{
                descendants: false,
                parents: false,
              }}
            />
          )}
          {isDropOver && canDrop && (
            <div className={styles.dropoverlay}>
              <NoFilesIcon className={styles.iconee} />
              <div className={styles.emptyTitle}>{t("dossier.dropFiles")}</div>
            </div>
          )}

          {/* {apiRef?.current?.getRowsCount() === 0 &&
            !isDropOver &&
            !isDossierLoading &&
            !onlyDesk && (
              <div className={styles.nocontent}>
                <NoFilesIcon className={styles.iconee} />
                <div className={styles.emptyTitle}>
                  Upuść <span>plik</span> tutaj lub
                </div>
                <Button
                  className={styles.buttonAddFile}
                  text="Wybierz plik z dysku"
                  onClick={handleClickAdd}
                />
              </div>
            )} */}

          <div className={styles.hidden}>
            <input
              ref={fileInputRef}
              type="file"
              onChange={(e) => onDrop(Array.from(e.target.files))}
              multiple
            />
          </div>
        </div>

        {contextMenu && (
          <MenuCell
            apiRef={apiRef}
            element={contextMenu?.Item}
            caseId={caseId}
            parentKeys={[] /* todo parentKeys*/}
            handleFileDoubleClick={handleFileDoubleClick}
            refetchAll={refetch}
            handleCreateVersion={(i) => {
              setActiveElement(i);
              setShowCreateVersion(true);
            }}
            handleMove={(i) => {
              setActiveElement(i);
              setShowMove(true);
            }}
            handleShare={(i) => {
              setActiveElement(i);
              setShowShare(true);
            }}
            menuOnly={true}
            isTrash={isTrashView}
            virtualElement={{
              getBoundingClientRect: () =>
                new DOMRect(contextMenu.X, contextMenu.Y),
            }}
          ></MenuCell>
        )}

        {showDelete && (
          <ConfirmModal
            title={t("modals.deleteTitle")}
            text={t("modals.deleteText")}
            acceptLabel={t("common.delete")}
            cancelLabel={t("common.cancel")}
            onAccept={() => {
              setShowDelete(false);
              deleteInternal();
            }}
            onCancel={() => setShowDelete(false)}
          />
        )}

        {showEmptyTrash && (
          <ConfirmModal
            title={t("dossier.emptyTrashConfirmTitle")}
            text={t("dossier.emptyTrashConfirmText")}
            acceptLabel={t("dossier.emptyTrash")}
            cancelLabel={t("common.cancel")}
            showDontShowNextTime={false}
            onAccept={() => {
              emptyTrash(undefined, {
                onSuccess: () => {
                  notification({
                    type: ENotificationType.SUCCESS,
                    title: t("dossier.emptyTrashDoneTitle"),
                    text: t("dossier.emptyTrashDoneText"),
                  });
                  refetch();
                  setShowEmptyTrash(false);
                },
                onError: () => {
                  notification({
                    type: ENotificationType.ERROR,
                    title: t("common.error"),
                    text: t("dossier.emptyTrashError"),
                  });
                  setShowEmptyTrash(false);
                },
              });
            }}
            onCancel={() => setShowEmptyTrash(false)}
          />
        )}

        {showPreview && previewItem && (
          <ModalLayout
            dock={DockPosition.FULLSCREEN_CENTER}
            customY={10}
            isAnimation={false}
            ignore={false}
            toggle={() => setShowPreview(false)}
            refWrapper={wrapperRef}
            showBg={true}
          >
            <PreviewModal
              itemId={previewItem.ParentId ?? previewItem.Id}
              itemKind={previewItem.Kind}
              fileUri={previewItem.FileUri}
              encryptionKeyId={previewItem.EncryptionKeyId}
              fileName={previewItem.FileName}
              toggle={() => setShowPreview(false)}
              refetch={() => refetch()}
            ></PreviewModal>
          </ModalLayout>
        )}

        {showFolderPreview && previewItem && (
          <ModalLayout
            dock={DockPosition.FULLSCREEN_CENTER}
            customY={10}
            isAnimation={false}
            ignore={false}
            toggle={() => setShowFolderPreview(false)}
            refWrapper={wrapperRef}
            showBg={true}
          >
            <DossierFolderModal
              folderId={previewItem.Id}
              caseId={previewItem?.CaseId ?? ""}
              toggle={() => setShowFolderPreview(false)}
              refetch={() => refetch()}
            ></DossierFolderModal>
          </ModalLayout>
        )}

        {showPreviewCase && previewItem && (
          <ModalLayout
            dock={DockPosition.FULLSCREEN_CENTER}
            customY={10}
            isAnimation={false}
            ignore={false}
            toggle={() => setShowFolderPreview(false)}
            refWrapper={wrapperRef}
            showBg={true}
          >
            <CasePreviewModal
              caseId={previewItem?.CaseId ?? ""}
              toggle={() => setShowPreviewCase(false)}
              refetch={() => refetch()}
            ></CasePreviewModal>
          </ModalLayout>
        )}
      </div>

      {showPluginError && (
        <PluginNotExist handleClose={() => setShowPluginError(false)} />
      )}

      {showCreateVersion && (
        <ModalLayout
          dock={DockPosition.DISABLED}
          off={true}
          customX={1}
          isAnimation={true}
          customY={0}
          ignore
          fullHeight={true}
        >
          <DossierCreateVersionModal
            toggle={setShowCreateVersion}
            item={activeElement}
            refetch={refetch}
          />
        </ModalLayout>
      )}

      {showShare && (
        <ModalLayout
          dock={DockPosition.DISABLED}
          off={true}
          customX={1}
          isAnimation={true}
          customY={0}
          ignore
          fullHeight={true}
        >
          <PackageEditSharesModal
            toggle={() => setShowShare(false)}
            item={activeElement}
            refetch={refetch}
          />
        </ModalLayout>
      )}

      {showMove && (
        <ModalLayout
          dock={DockPosition.DISABLED}
          off={true}
          customX={1}
          isAnimation={true}
          customY={0}
          ignore
          fullHeight={true}
        >
          <DossierMoveModal
            toggle={setShowMove}
            sourceCaseId={caseId ?? ""}
            item={activeElement}
            refetch={refetch}
          />
        </ModalLayout>
      )}
    </>
  );
};

export default CaseDossier;
